// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
    min-height: 100vh;
    background-color: #f0f2f5;
}

.app-content {
    padding: 24px;
    margin: 0 auto;
}

.dark-remove-icon .ant-upload-list-item-actions .anticon-delete svg {
    fill: rgba(0, 0, 0, 0.85) !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".app-container {\n    min-height: 100vh;\n    background-color: #f0f2f5;\n}\n\n.app-content {\n    padding: 24px;\n    margin: 0 auto;\n}\n\n.dark-remove-icon .ant-upload-list-item-actions .anticon-delete svg {\n    fill: rgba(0, 0, 0, 0.85) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
